export const NOTIFICATION_TYPES = {
  INFO: 1,
  CONFIRM: 2,
  SELF_REQUEST: 3,
  SERVICE: 4,
  EMERGENCY: 5,
  MISSED_CALL: 6,
  UNASSIGNED: 7,
  UNASSIGNED_CONFIRM: 8,
  MEDIA: 9,
  SMS: 10,
  AUTOSYNC:11
};

export const CONFIRMATION_TYPES = {
  READ_STATUS_UPDATE: -1,
  NO_CHANGE: 1,
  REQUEST_PENDING: 2,
  REQUEST_ACCEPTED: 3,
  OWNER_DECLINED: 4,
  ALL_USERS_DECLINED: 5,
  AUTOMATIC_DECLINED: 6,
  REQUEST_REJECTED: 7,
  SCHEDULE_CHANGE_REQUESTED: 8,
  SERVICE_ACCEPTED: 9,
  REQUEST_ACCEPTandSYNC: 10,
  DELETE:11
};
